export const lineHierarchyTypes = {
    line: "Categorías principales",
    subline: "Subcategorías",
    "": "Todas"
};
